import androidLogo from "@assets/images/android-logo.avif";
import iosLogo from "@assets/images/ios-logo.avif";
import mobileAppsLogo from "@assets/images/icon-for-cross-platform-mobile-apps.avif";
import IoTAppsLogo from "@assets/images/icon-for-IoT-and-wearables-integrated-mobile-apps.avif";
import gamingAppsLogo from "@assets/images/icon-for-gaming-mobile-apps.avif";
import hybridAppsLogo from "@assets/images/icon-for-hybrid-mobile-apps.avif";
import circuitDesignIcon from '@assets/images/IoT-development/circuit-design-icon.avif';
import firmwareSoftwaredeveopmentIcon  from '@assets/images/IoT-development/firmware-Software-deveopment-icon.avif';
import IoTDesktopAppIcon from '@assets/images/IoT-development/IoT-desktop-App-icon.avif'
import IoTMobileAppIcon from '@assets/images/IoT-development/IoT-mobile-app-icon.avif'
import IoTProductIcon from '@assets/images/IoT-development/IoT-product-icon.avif'
import IoTSensorIcon from '@assets/images/IoT-development/IoT-sensor-icon.avif'
import IoTWebAppIcon  from '@assets/images/IoT-development/IoT-web-app-icon.avif'


export const cardData = [
    {
         heading: 'Circuit design',
        text: "We engineer high-performance PCB layouts and microcontroller architectures tailored to your device's specific power and processing requirements. Our designs prioritize long-term stability and optimal form factors, ensuring your hardware survives the rigors of its intended environment.",
        img:circuitDesignIcon,
    }, {
  heading:"Sensor selection",
  text:"We help you navigate the vast landscape of affordable IoT sensors and industrial IoT sensors to find the perfect match for your data collection needs. Whether your project requires precision environmental monitoring or high-speed motion tracking, we select components that balance cost with scientific accuracy.",
  img:IoTSensorIcon,
    },{
      heading:"Product assembly & prototyping",
        text:"Our team transforms digital blueprints into functional prototype smart devices that allow for real-world testing and investor demonstrations. We iterate quickly to refine hardware ergonomics and functional reliability, ensuring your IoT devices are ready for the stresses of field use.",
        img:IoTProductIcon,
    },
    {
      heading:"IoT Web Apps ",
        text:"We build powerful, responsive web dashboards that provide unified device management and real-time data visualization from any browser. These IoT platform solutions allow administrators to oversee remote devices, manage users, and analyze trends through a centralized command center.",
        img:IoTWebAppIcon,
    },
    {
      heading:"IoT Mobile Apps ",
        text:"Our IoT app development services create intuitive mobile interfaces that connect users to their hardware via Bluetooth, Wi-Fi, or cellular built-in wireless connectivity. We focus on world-class IoT app design to ensure a frictionless user experience across both iOS and Android platforms.",
        img:IoTMobileAppIcon,
    },
    {
      heading:"IoT Desktop Apps",
        text:"For industrial automation or complex engineering tasks, we develop robust desktop applications capable of handling intensive local data transmission and processing. These applications provide high-performance interfaces for managing local hardware clusters without relying solely on cloud latency.",
        img:IoTDesktopAppIcon,
    },
    {
      heading:"Firmware & Embedded Software",
        text:"We write the low-level code that brings your hardware to life, ensuring efficient I/O signal management and autonomous operation. Our firmware supports secure over-the-air (OTA) updates, keeping your devices protected and functional throughout their entire lifecycle.",
        img: firmwareSoftwaredeveopmentIcon,
    },
]